import gettext, { ngettext } from '@sdk/lang/gettext';
import { GROUP_TYPE_LABELS } from '@sdk/authentication/constants';
import { Persona } from '@sdk/personaCollection/types/Persona';
import { isUser } from '@sdk/users/utils/guards';

import { MessagePersona } from '@web/conversations/types/Message';

const getDisplayName = (persona: Persona) => {
  if (isUser(persona)) {
    return persona.isMe ? gettext('You') : persona.fullname;
  }

  const type = GROUP_TYPE_LABELS[persona.type] as string;
  if (type) {
    return `${persona.name} (${type})`;
  }

  return persona.name;
};

export const getRemovalMetaMessage = (message: MessagePersona) => {
  const personaName = getDisplayName(message.firstPersona);

  const othersCount = message.personaCount - 1;

  if (othersCount > 0) {
    return ngettext(
      '%(name)s and %(othersCount)s other left this conversation',
      '%(name)s and %(othersCount)s others left this conversation',
      othersCount,
      { name: personaName, othersCount }
    );
  }

  return gettext('%(name)s left this conversation', { name: personaName });
};

export const getAdditionMetaMessage = (message: MessagePersona) => {
  const firstPersonaName = getDisplayName(message.firstPersona);

  if (message.personaCount === 1) {
    return gettext('%(name)s joined this conversation', { name: firstPersonaName });
  }

  const secondPersonaName = getDisplayName(message.secondPersona);
  if (message.personaCount === 2) {
    return gettext('%(name)s and %(secondName)s joined this conversation', {
      name: firstPersonaName,
      secondName: secondPersonaName,
    });
  }

  const othersCount = message.personaCount - 2;

  if (othersCount === 1) {
    return gettext('%(name)s, %(secondName)s and 1 other joined this conversation', {
      name: firstPersonaName,
      secondName: secondPersonaName,
    });
  }

  return gettext('%(name)s, %(secondName)s and %(othersCount)s others joined this conversation', {
    name: firstPersonaName,
    othersCount,
    secondName: secondPersonaName,
  });
};
